import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Llevaba 3 años tomando la píldora y NUNCA había entendido realmente cómo funcionaba. Esta guía me lo explicó en lenguaje normal. El módulo de qué hacer si olvidas solo ya vale el precio completo.',
  name: 'María G.',
  age: '28 años',
  country: '🇨🇴',
  initials: 'MG',
  photo: 'https://cdn.magicpatterns.com/uploads/hbH3zzyBKetvY31hihWdqg/maria_g_34_anos.png'
}, {
  quote: 'Empecé la píldora el mes pasado y tenía mucho miedo por los efectos secundarios. Gracias a esta guía supe que lo que sentía era completamente normal.',
  name: 'Valentina R.',
  age: '23 años',
  country: '🇲🇽',
  initials: 'VR',
  photo: 'https://cdn.magicpatterns.com/uploads/3dcxC8F6aeJnHTaLEnts3V/Valentina_r_28_anos.png'
}, {
  quote: 'Los calendarios y checklists son una maravilla. Llevo 2 meses sin olvidar ni UNA pastilla. Antes olvidaba 3 o 4 por ciclo.',
  name: 'Daniela M.',
  age: '31 años',
  country: '🇪🇸',
  initials: 'DM',
  photo: 'https://cdn.magicpatterns.com/uploads/pTbjQJkgWpCvG5r78CqGBQ/Daniela_P_26_anos.png'
}, {
  quote: 'Por fin alguien explica los mitos reales sobre peso e infertilidad. Esta guía tiene todo con fuentes médicas reales. La recomiendo 100%.',
  name: 'Andrea S.',
  age: '26 años',
  country: '🇦🇷',
  initials: 'AS',
  photo: 'https://cdn.magicpatterns.com/uploads/fuv2P4fPMHhPA2iVAB7fpV/andrea_s_26.png'
}, {
  quote: 'Me olvidé dos pastillas seguidas y entré en pánico. Abrí la guía, seguí el árbol de decisión y supe qué hacer en 2 minutos.',
  name: 'Camila T.',
  age: '24 años',
  country: '🇵🇪',
  initials: 'CT',
  photo: 'https://cdn.magicpatterns.com/uploads/7DXLTwfr6nG1u4FA2yZzjb/camla_t_24.png'
}, {
  quote: 'No es solo información, tiene calendario imprimible, checklist, tarjeta de emergencia para la billetera... Es una guía completa DE VERDAD.',
  name: 'Sofía L.',
  age: '29 años',
  country: '🇨🇱',
  initials: 'SL',
  photo: 'https://cdn.magicpatterns.com/uploads/2iBCXbuREFAWqQDPgUW4Lp/sofia_l29.png'
}];
export function Testimonials() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto bg-brand-cardPink/20 rounded-[2rem] my-12" data-id="element-229">
      <div className="text-center mb-16" data-id="element-230">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-dark" data-id="element-231">
          Lo que dicen las mujeres que ya la tienen:
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-232">
        {testimonials.map((test, index) => <motion.div key={index} initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white p-8 rounded-[16px] shadow-sm border border-brand-cardPurple/30 flex flex-col h-full" data-id="element-233">
            <div className="flex gap-1 mb-4" data-id="element-234">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-235" />)}
            </div>
            <p className="text-brand-dark italic mb-6 flex-grow" data-id="element-236">
              "{test.quote}"
            </p>
            <div className="flex items-center gap-4 mt-auto" data-id="element-237">
              {test.photo ? <img src={test.photo} alt={test.name} className="w-14 h-14 rounded-full object-cover shrink-0 ring-2 ring-brand-cardPink" data-id="element-238" /> : <div className="w-14 h-14 rounded-full bg-gradient-primary flex items-center justify-center text-white font-bold text-lg shrink-0" data-id="element-239">
                  {test.initials}
                </div>}
              <div data-id="element-240">
                <p className="font-bold text-brand-dark" data-id="element-241">{test.name}</p>
                <p className="text-sm text-brand-secondary" data-id="element-242">
                  {test.age} {test.country}
                </p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}